module.exports = __webpack_public_path__ + "static/media/360Experience.9bf9052c.mp4";